var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tipspage"}},[_c('div',[_c('img',{attrs:{"src":require("../../../static/img/404.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"saveBtn"},[_c('div',{on:{"click":_vm.roteView}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("立即返回")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66ca2051","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/tipspage/index.vue
// module id = null
// module chunks = 